import { CriterionInterfaceV1 } from './CriterionInterfaceV1';
import { CriterionInputType } from '../../../infra/startup/types';
import * as T from './types';

let criterionInterfaceV1: CriterionInterfaceV1;

export function getCriterionInterfaceV1(): T.CriterionInterfaceType<any> {
  if (!criterionInterfaceV1) {
    throw new Error(
      'CriterionInterfaceV1 not initialized. Call initializeCriterionInterfaceV1 first.'
    );
  }
  return criterionInterfaceV1.getInterface();
}

export function getCriterionSingleton(): T.CriterionInterfaceType<any> {
  return getCriterionInterfaceV1();
}

export function clearCriterionSingleton(): void {
  criterionInterfaceV1 = undefined;
}

export async function initializeCriterionInterfaceV1(): Promise<
  T.CriterionInterfaceType<any>
> {
  if (criterionInterfaceV1) return criterionInterfaceV1.getInterface();

  criterionInterfaceV1 = new CriterionInterfaceV1();

  return criterionInterfaceV1.getInterface();
}
